<template>
  <footer class="public-footer">
    <router-link to="policy" class="nav-link">Privacy policy</router-link>
    <p>support@streamboxtv.live</p>
    <p>© 2025 StreamboxTV. All rights reserved.</p>
  </footer>
</template>

<style scoped>
.public-footer {
  background: #222;
  color: #aaa;
  text-align: center;
  padding: 1rem;
}
</style>